"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.default = react_1.createContext({});
//# sourceMappingURL=AppContext.js.map